import React, { useState } from 'react';
import { LogOut, Menu, KeyRound } from 'lucide-react';
import { Button } from '../components/ui/button';
import { resolvePublicAssetUrl } from '../lib/publicAssetUrl';
import ChangePasswordModal from '../components/auth/ChangePasswordModal';

const Header = ({ user, sidebarOpen, onToggleSidebar, onLogout }) => {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  return (
    <>
      <header
        className="sticky top-0 z-50 flex h-16 shrink-0 items-center justify-between gap-3 border-b border-white/10 shadow-md px-3 sm:px-5 text-white transition-all duration-300"
        style={{ background: 'var(--primary-gradient)' }}
      >
        <div className="flex min-w-0 items-center gap-2 sm:gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={onToggleSidebar}
            className="h-10 w-10 shrink-0 text-white hover:bg-white/10"
            aria-label={sidebarOpen ? 'Hide menu' : 'Show menu'}
          >
            <Menu className="h-5 w-5" />
          </Button>
          <img
            src={resolvePublicAssetUrl(
              user?.blurasagalogo || user?.theme_logo || '/blura_saga_logo.jpg'
            )}
            alt={user?.blurasagatitle || user?.theme_name || 'Bengaluru Police Saga'}
            className="h-10 w-10 shrink-0 rounded-lg object-cover ring-1 ring-cyan-500/50"
          />
          <div className="min-w-0 leading-tight">
            <h1 className="truncate font-heading text-base font-bold tracking-[0.12em] text-white sm:text-xl">
              {user?.blurasagatitle || user?.theme_name || 'Bengaluru Police Saga'}
            </h1>
            <p className="hidden truncate text-[10px] font-semibold uppercase tracking-widest text-white/90 sm:block">
              {user?.blurasagadescription || user?.theme_description || 'Cyber Intelligence Platform'}
            </p>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2 sm:gap-3">
          <div className="hidden text-right sm:block">
            <div className="max-w-[140px] truncate text-sm font-bold text-white">
              {user?.name}
            </div>
            <div className="text-[10px] font-semibold uppercase tracking-wide text-white/90">
              {user?.role}
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsPasswordModalOpen(true)}
            className="h-9 w-9 text-white hover:bg-white/10"
            title="Change Password"
            aria-label="Change Password"
          >
            <KeyRound className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onLogout}
            className="h-9 w-9 text-white hover:bg-red-500/20 hover:text-red-200"
            title="Logout"
            aria-label="Logout"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </header>

      <ChangePasswordModal
        isOpen={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
      />
    </>
  );
};

export default Header;
